'use es6';

import { H3 } from 'foundations-components/transitional/components/H3';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Button } from 'foundations-components/transitional/components/Button';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import reviewState from '../constants/reviewState';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// import PropTypes from 'prop-types';
import { useEffect } from 'react';
import getEventKey from '../utils/getEventKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InformationModal = ({
  toggleModal,
  status,
  contentType,
  usageTracker
}) => {
  useEffect(() => {
    if (usageTracker && status && status !== reviewState.OK) {
      usageTracker.track(getEventKey(contentType), {
        action: 'info-modal-loaded'
      });
    }
  }, []); // eslint-disable-line

  if (!status || status === reviewState.OK) return null;
  return /*#__PURE__*/_jsxs(Modal, {
    centered: true,
    "data-test-id": "modal-test",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `contentLabel.${status}.popupTitle`
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: toggleModal
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Paragraph, {
        children: status === reviewState.IN_REVIEW && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `contentLabel.${status}.popupIntro.${contentType}`
        })
      }), /*#__PURE__*/_jsx(Paragraph, {
        textAlign: "left",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `contentLabel.${status}.popupTextForContent.${contentType}`
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: toggleModal,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `contentLabel.popupCloseButton`
        })
      })
    })]
  });
};

// InformationModal.propTypes = {
//   status: PropTypes.string.isRequired,
//   toggleModal: PropTypes.func.isRequired,
//   contentType: PropTypes.string.isRequired,
//   // eslint-disable-next-line react/no-unused-prop-types
//   slaCopyType: PropTypes.string,
//   usageTracker: PropTypes.object,
// };

export default InformationModal;